module.exports = __webpack_public_path__ + "img/history_white_icon.6a13d29e.png";